import { Node } from '@tiptap/core'

const PageBreak = Node.create({
  name: 'pageBreak',
  priority: 100,

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  renderHTML({ node, HTMLAttributes }) {
    return ['div', HTMLAttributes, '']
  },

  content: '',
  group: 'block',
  selectable: false,
})

export default PageBreak
